import { render, staticRenderFns } from "./orderHandleFlow.vue?vue&type=template&id=642979bf&scoped=true"
import script from "./orderHandleFlow.vue?vue&type=script&lang=js"
export * from "./orderHandleFlow.vue?vue&type=script&lang=js"
import style0 from "./orderHandleFlow.vue?vue&type=style&index=0&id=642979bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642979bf",
  null
  
)

export default component.exports